import { render, staticRenderFns } from "./UserFormModal.vue?vue&type=template&id=1a86e995&scoped=true"
import script from "./UserFormModal.vue?vue&type=script&lang=js"
export * from "./UserFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86e995",
  null
  
)

export default component.exports